import { Button } from '@/components/ui/button'
import { FloatingActionIslandContent } from '@/components/ui/FloatingActionIslandContent'
import { useFormChangeTracking } from '@/components/ui/form'
import { toast } from 'sonner'
import type { UseFormReturn } from 'react-hook-form'
import type { FormValues } from './agent-detail.schema'

type AgentDetailSaveIslandProps = {
  form: UseFormReturn<FormValues>
  onSubmit: (values: FormValues) => Promise<boolean>
  isNewAgent: boolean
  agent: { id: string } | null
  saving: boolean
}

export function AgentDetailSaveIsland({
  form,
  onSubmit,
  isNewAgent,
  agent,
  saving,
}: AgentDetailSaveIslandProps) {
  const { hasUnsavedChanges, changedFieldsCount } = useFormChangeTracking()

  const handleSubmit = async (values: FormValues) => {
    const success = await onSubmit(values)
    if (success) {
      form.reset(values)
    }
  }

  const shouldShow = hasUnsavedChanges || isNewAgent

  return (
    <FloatingActionIslandContent
      show={shouldShow}
      componentId="agent-detail-save"
      priority={20}
    >
      <div className="inline-flex w-full max-w-2xl">
        <div className="flex flex-grow items-center mr-4 space-x-2 text-sm text-gray-600 dark:text-muted-foreground whitespace-nowrap pointer-events-none">
          <span className="font-medium">
            {isNewAgent && !hasUnsavedChanges
              ? 'New agent ready to create'
              : `${changedFieldsCount} unsaved ${changedFieldsCount === 1 ? 'change' : 'changes'}`}
          </span>
        </div>
        <div className="flex justify-end items-center space-x-2 pointer-events-auto">
          <Button
            onClick={form.handleSubmit(handleSubmit, errors => {
              console.error('Form validation errors:', errors)
              toast.error('Please fill in all required fields')
            })}
            disabled={saving}
            size="sm"
            variant="form"
          >
            {saving ? 'Saving...' : agent ? 'Update agent' : 'Create agent'}
          </Button>
        </div>
      </div>
    </FloatingActionIslandContent>
  )
}
